<p-dialog [baseZIndex]="2000" [(visible)]="modal" [closable]="false" [closeOnEscape]="false" [dismissableMask]="false"
    [modal]="true" [position]="'center'" [draggable]="false">
    <div class="pr-3 pl-3">
        <h3 class="text-primary bold">Upload</h3>
        <div class="form-group mt-4">
            <span class="text-muted">Document</span><b class="text-red ml-2" *ngIf="!preview">*</b>
            <div class="upload-container d-flex justify-content-center cursor-pointer" (click)="uploader.click()">
                <a class="btn btn-dark bg-lightgray bold" *ngIf="!preview" [attr.disabled]="processing">
                    <i class="fas fa-file-upload pr-3" aria-hidden="true"></i>Upload Document
                </a>
    
                <div class="text-center" *ngIf="preview">
                    <i class="fas fa-file-pdf text-danger cursor-pointer"
                        *ngIf="file?.type === 'application/pdf'" title="Click to upload"></i>
                    <br>
                    <span>{{ document?.name || file?.name }}</span>
                </div>
    
                <input type='file' accept=".pdf" (change)="previewUploadFile($event)" #uploader hidden
                    [disabled]="processing" />
            </div>
        </div>
        <div class="form-group" [formGroup]="form" *ngIf="form">
            <span class="text-muted">Assign Doctor to this LOA</span><b class="text-red ml-2"
                *ngIf="getControl('md_id')?.errors?.required">*</b>
            <app-doctor-autocomplete [doctorType]="'telemed7'" [(ngModel)]="form.controls['md_id'].value"
                (select)="getControl('md_id').setValue($event?.md_id)"
                (clear)="getControl('md_id').setValue(null)"></app-doctor-autocomplete>
        </div>
    </div>
    
    <p-footer>
        <div class="w-100 text-right pr-3 pl-3 pb-3">
            <button role="button" class="btn btn-primary btn-lg mr-2" (click)="confirmUpload()"
                [disabled]="processing || form?.invalid || !preview">
                {{ document ? 'Update' : 'Upload and Send to Doctor' }}
                <i *ngIf="processing" class="ml-2 nav-icon fas fa-circle-notch spinning"></i>
            </button>
            <button role="button" class="btn btn-outline-primary btn-lg" (click)="onClose()" [disabled]="processing">
                Close
            </button>
        </div>
    </p-footer>
</p-dialog>

<p-dialog [(visible)]="confirmationModal" [baseZIndex]="2000" [closable]="false" [modal]="true" [position]="'center'">
    <div class="text-center">
        <h5 class="text-warning">Are you sure you want to {{ document ? 'update' : 'Upload and Send to Doctor' }} this
            document?</h5>
        <div class="mt-3">
            <button class="btn btn-primary mr-2" (click)="upload()">Yes</button>
            <button class="btn btn-outline-danger" (click)="cancelUpload()">No</button>
        </div>
    </div>
</p-dialog>